"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Tether = require("tether");
var Provider_types_1 = require("../Provider/Provider.types");
var TetherComponentPortal = /** @class */ (function (_super) {
    __extends(TetherComponentPortal, _super);
    function TetherComponentPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.updateTether = function () {
            var _a = _this.props, renderElementTag = _a.renderElementTag, renderElementTo = _a.renderElementTo, rewriteTetherOptionsAfterMount = _a.rewriteTetherOptionsAfterMount, options = __rest(_a, ["renderElementTag", "renderElementTo", "rewriteTetherOptionsAfterMount"]);
            var tetherOptions = __assign({ attachment: _this.props.attachment, target: _this.targetNode, element: _this.elementParentNode }, options);
            if (!_this.tether) {
                _this.tether = new Tether(rewriteTetherOptionsAfterMount(tetherOptions));
            }
            else {
                _this.tether.setOptions(rewriteTetherOptionsAfterMount(tetherOptions));
            }
            _this.tether.position();
        };
        _this.elementParentNode = document.createElement(props.renderElementTag);
        _this.elementParentNode.setAttribute('data-version', Provider_types_1.elementsVersion);
        _this.elementParentNode.setAttribute('data-root', '');
        _this.elementParentNode.setAttribute('data-theme', _this.props.theme);
        return _this;
    }
    Object.defineProperty(TetherComponentPortal.prototype, "_renderNode", {
        get: function () {
            var renderElementTo = this.props.renderElementTo;
            /* istanbul ignore if */
            if (typeof renderElementTo === 'string') {
                return document.querySelector(renderElementTo);
            }
            else {
                return renderElementTo || document.body;
            }
        },
        enumerable: true,
        configurable: true
    });
    TetherComponentPortal.prototype.componentDidMount = function () {
        this.targetNode = ReactDOM.findDOMNode(this.props.targetComponent);
        // append node to the end of the body
        this._renderNode.appendChild(this.elementParentNode);
        this.updateTether();
    };
    TetherComponentPortal.prototype.componentWillUnmount = function () {
        if (this.tether) {
            this.tether.destroy();
        }
        this._renderNode.removeChild(this.elementParentNode);
        this.elementParentNode = null;
        this.tether = null;
    };
    TetherComponentPortal.prototype.componentDidUpdate = function (prevProps) {
        this.updateTether();
        if (this.props.theme !== prevProps.theme) {
            this.elementParentNode.setAttribute('data-theme', this.props.theme);
        }
    };
    TetherComponentPortal.prototype.render = function () {
        return ReactDOM.createPortal(this.props.children, this.elementParentNode);
    };
    TetherComponentPortal.defaultProps = {
        renderElementTag: 'div',
        renderElementTo: null,
        rewriteTetherOptionsAfterMount: /* istanbul ignore next */ function (/* istanbul ignore next */ options) { return options; }
    };
    return TetherComponentPortal;
}(React.Component));
exports.TetherComponentPortal = TetherComponentPortal;
exports.default = TetherComponentPortal;
//# sourceMappingURL=TetherComponentPortal.js.map